import {Component} from '@angular/core';

@Component({
  selector: 'cars-reorder',
  templateUrl: './reorder.component.html',
  styleUrls: ['./reorder.component.scss'],
})
export class ReorderComponent {}
